import { render, staticRenderFns } from "./DashboardEquipes.vue?vue&type=template&id=053a6ff5"
import script from "./DashboardEquipes.vue?vue&type=script&lang=js"
export * from "./DashboardEquipes.vue?vue&type=script&lang=js"
import style0 from "./DashboardEquipes.vue?vue&type=style&index=0&id=053a6ff5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports